"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnalyticsClick = void 0;
var react_1 = require("react");
var utils_1 = require("../../utils");
var use_analytics_1 = require("../lib/use-analytics");
var AnalyticsClick = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, name = _a.name, properties = _a.properties;
    var dispatch = (0, use_analytics_1.useAnalytics)().dispatch;
    var child = react_1.Children.only(children);
    var onClick = child.props.onClick;
    var analyticsOnClick = function (event) {
        if (onClick) {
            onClick(event);
        }
        dispatch({ type: 'click', name: name, properties: properties });
    };
    var mergedRef = (0, utils_1.mergeRefs)(ref, child.ref);
    return (0, react_1.cloneElement)(child, { onClick: analyticsOnClick, ref: mergedRef });
});
exports.AnalyticsClick = AnalyticsClick;
